import { ENDPOINTS } from '../utils/endpoints'
import { getAPIwithToken } from '../utils/fetchApi'

export interface ProfileData {
  id: number
  userId: string
  name: string
  email: string
  type: string
  role: string
  phone?: string
  employeeId?: string
  designation?: string
  dateOfBirth?: string
  address?: string
  [key: string]: any
}

export interface ProfileResponse {
  status: string
  message: string
  data: ProfileData
}

export async function getProfile(): Promise<ProfileResponse> {
  return getAPIwithToken<ProfileResponse>(ENDPOINTS.PROFILE)
}
